<template lang="pug">
  .b-change Удалил(а) комментарий {{ name }} от {{ date }}
</template>

<script>
import utils from '@/utils/common';

export default {
  name: 'TaskChangeStatus',
  props: {
    change: Object,
  },
  computed: {
    name() {
      const user = this.change.users[0];
      return `${user.name} ${user.surname}`;
    },
    date() {
      return utils.convertDateToString(new Date(this.change.updatedAt), 'long', true, true);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
